import React from 'react'
import { Link } from 'react-router-dom'
import { ParallaxBanner, ParallaxBannerLayer } from 'react-scroll-parallax';

const Zed50Banner = () => (
  <div id="zed50-banner" style={{ backgroundColor: '#662e91', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
    <div style={{ display: 'block', position: 'relative', backgroundImage: 'url("/assets/4ZZZ50-program-poster.svg")', backgroundSize: 'contain' }}>
    </div>
  </div>


)

export default Zed50Banner
